import { render } from "./basic_user_card.vue?vue&type=template&id=13057dd8"
import script from "./basic_user_card.js?vue&type=script&lang=js"
export * from "./basic_user_card.js?vue&type=script&lang=js"

import "./basic_user_card.vue?vue&type=style&index=0&id=13057dd8&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__